import React from 'react';

const Footer = () => {
	return <footer className='footer'>&copy; Krzysztof Pawłowski</footer>;
};

export default Footer;
